/**
 * Data layer for `permission-scopes-link-payout-team-invoice-automat`. Thin typed fetch wrappers over /api/v1/permission-scopes-link-payout-team-invoice-automat.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface PermissionScopesLinkPayoutTeamInvoiceAutomatRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListPermissionScopesLinkPayoutTeamInvoiceAutomatResponse {
	count: number;
	items: PermissionScopesLinkPayoutTeamInvoiceAutomatRow[];
}

export interface CreatePermissionScopesLinkPayoutTeamInvoiceAutomatBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/permission-scopes-link-payout-team-invoice-automat";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListPermissionScopesLinkPayoutTeamInvoiceAutomatResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListPermissionScopesLinkPayoutTeamInvoiceAutomatResponse>(res);
}

export async function create(body: CreatePermissionScopesLinkPayoutTeamInvoiceAutomatBody): Promise<PermissionScopesLinkPayoutTeamInvoiceAutomatRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<PermissionScopesLinkPayoutTeamInvoiceAutomatRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys = {
	all: ["permission-scopes-link-payout-team-invoice-automat"] as const,
	list: () => [...permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys.all] as const,
	detail: (id: string) => [...permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys.all, id] as const,
};
